import {
  getInitializationState,
  initializeCategoryCode
} from "@/utils/initializeCategoryCode";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useEffect, useState } from "react";

const queryClient = new QueryClient();

interface ReactQueryProviderProps {
  children: React.ReactNode;
}

function ReactQueryProvider({ children }: ReactQueryProviderProps) {
  const [isInit, setIsInit] = useState(false);

  useEffect(() => {
    (async () => {
      if (getInitializationState() === "init") {
        await initializeCategoryCode();
        setIsInit(true);
      }
    })();
  }, []);

  return (
    isInit && (
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    )
  );
}

export default ReactQueryProvider;
